import { createContext, useContext, useEffect, useState } from "react";
import api from '../services/api';
import { useAuth } from "../context/AuthContext"; // Import Auth Context to listen for login changes

const AgentContext = createContext();

export const AgentProvider = ({ children }) => {
  const [agent, setAgent] = useState(null);
  const { user } = useAuth(); // Get the logged-in user from AuthContext

  useEffect(() => {
    if (!user) return; // Prevent fetching if the user is not logged in

    api.get("/Companies/Agents")
      .then((response) => setAgent(response.data))
      .catch((error) => console.error("Error fetching agent:", error));
  }, [user]); // Re-fetch when the user changes

  return <AgentContext.Provider value={agent}>{children}</AgentContext.Provider>;
};

export const useAgents = () => useContext(AgentContext);